import { render, staticRenderFns } from "./feedbackList.vue?vue&type=template&id=38bf7de8&scoped=true&"
import script from "./feedbackList.vue?vue&type=script&lang=js&"
export * from "./feedbackList.vue?vue&type=script&lang=js&"
import style0 from "./feedbackList.vue?vue&type=style&index=0&id=38bf7de8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38bf7de8",
  null
  
)

export default component.exports